import { NavigationLinkInterface } from "../types/navigation/NavigationLinkInterface"

export const navData:NavigationLinkInterface={
    from:"",
    backActive:false,
}